import { Amplify } from 'aws-amplify';
import React from 'react'
import ReactDOM from 'react-dom/client'
import amplifyConfig from './amplifyConfig';
import App from './App.tsx'

Amplify.configure(amplifyConfig);

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)
